<script lang="ts">
	import DoubleTimePicker from '../../../TimePicker/DoubleTimePicker.svelte';
	import { createEventDispatcher, getContext } from 'svelte';
	import { Container, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher();
	const nightModeStore: SvelteStore<any> = getContext('nightMode');
	const time = $nightModeStore.time;
</script>

<Container padding="0">
	<Text class="mb-m" element="h2">{$format('choose_time_interval')}</Text>

	<DoubleTimePicker
		{time}
		on:change={(e) => {
			dispatch('updateStore', { time: e.detail });
		}}
	/>
</Container>
